import Vue from 'vue';

Vue.options.delimiters = ['{%', '%}'];

export default Vue;
